import React, { useEffect, useRef } from 'react'
import { useState } from 'react'
import noicon from "../Images/Refer and Earn/notification.png"
// import profilepic from "../Images/profle.png"
import { useDispatch, useSelector } from 'react-redux'
import { deleteNotification, fetchAllNotifications, readAllNotifications } from '../Redux/Slice/NotificationSlice'
import { formatDateAgo } from '../utils/Helper'
import searchhomeprofileimg from "../../src/Images/searchhomeprofileimg.png";
import rewordsIcon from "../../src/Images/Reward.png";
import neooIcon from "../../src/Images/logo/icon.png";
import { Link } from 'react-router-dom'
import { confirmAlert } from 'react-confirm-alert'
import HttpClient from '../utils/HttpClient'
import toast from 'react-hot-toast'

const NotificationBar = ({ show, closeNotifiBar }) => {
    const { AllNotifications, status, error } = useSelector((state) => state.notification);
    const { UserProfileID } = useSelector((state) => state.app);
    const [menuNotificationID, setMenuNotificationID] = useState()
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch()
    const toggleDropdown = (e, id) => {
        e.preventDefault()
        setMenuNotificationID(id)
        // setIsOpen(!isOpen);
        // isOpen ? setIsOpen(true) : setIsOpen(!isOpen)
        // setIsOpen(true);
        setIsOpen(!isOpen);
    }

    const divRef = useRef(null);
    const handleClickOutside = (e) => {
        // Check if the click is outside the referenced div
        if (divRef.current && !divRef.current.contains(e.target)) {
            setIsOpen(false)
        }
    }

    useEffect(() => {
        // Add event listener when the component mounts
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Cleanup the event listener when the component unmounts
            document.removeEventListener('mousedown', handleClickOutside);
        };

    }, [])

    const ViewNotificationMessage = (e, msgText) => {
        e.preventDefault()
        confirmAlert({
            title: (
                <><h4>Message from Admin</h4><hr /></>
            ),
            message: (
                <div dangerouslySetInnerHTML={{ __html: msgText }} style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }} />
            ),
            buttons: [
                {
                    label: "Ok",
                }
            ],
        });
    }

    const [notificationDeleted, setNotificationDeleted] = useState(false)
    const handleDelete = (e, id) => {
        e.preventDefault()
        dispatch(deleteNotification(id))
        setNotificationDeleted(!notificationDeleted)
        // setMenuNotificationID(e.target.id)
        // setIsOpen(false)
    }

    const readNotification = () => {
        // e.preventDefault()
        //Call function to update read notification
        dispatch(readAllNotifications())
    }

    useEffect(() => {
        dispatch(fetchAllNotifications())
    }, [notificationDeleted])

    //Accept connection request
    const handleAcceptConnectionRequest = async (e, notificationId, senderId) => {
        e.preventDefault()
        const formData = {
            nonMemberId: UserProfileID?._id,
            // nonMemberId: senderId,
            connectionId: notificationId,
            acceptStatus: "Accept"
        };
        // return

        const res = await HttpClient.requestData(
            "save-nonmember-contacts",
            "POST",
            formData
        );
        if (res && res?.status) {
            // setShowPopup(!showPopup);
            toast.success("Request sent successfully");
        } else {
            toast.error("Contact Saving failed");
        }
    };

    return (
        <>
            <section className={`NotificationBar_wrap ${show ? 'show' : ''}`}>
                <div className='top_area'>
                    <h4 className='heading'>Notification</h4>
                    <button className='closebtn' onClick={() => {
                        readNotification();
                        closeNotifiBar();
                    }}><i className="fa-solid fa-xmark"></i></button>
                </div>
                <div className='content_wrap'>

                    {
                        AllNotifications
                            // .filter(item => item?.userId !== item?.visitedBy)
                            ?.length > 0 ? (
                            <>
                                {
                                    AllNotifications.map((item, index) => (

                                        // <div className='smsbox_wrap unread' key={index}>
                                        <div className='smsbox_wrap' key={index}>
                                            <div className='left'>
                                                <div className='profile'>
                                                    {
                                                        item.point ? <img src={rewordsIcon} className='img-fluid' alt='...' style={{ width: "40px", height: "40px", padding: "3px" }} /> :
                                                            item.postEnquiryId ? <img src={item?.enqueryByData[0]?.profilePhoto || searchhomeprofileimg} className='img-fluid' alt={item?.enqueryByData[0]?.personName} title={item?.enqueryByData[0]?.personName} /> :
                                                                item.visitedBy ? <Link to={`/profile/${item?.visitedByData[0]?.userName}`} onClick={() => {
                                                                    readNotification();
                                                                    closeNotifiBar();
                                                                }}><img src={item?.visitedByData[0]?.profilePhoto || searchhomeprofileimg} className='img-fluid' alt={item?.visitedByData[0]?.personName} title={item?.visitedByData[0]?.personName} /></Link> :
                                                                    item.likedBy ? <Link to={`/profile/${item?.likedByData[0]?.userName}`} onClick={() => {
                                                                        readNotification();
                                                                        closeNotifiBar();
                                                                    }}><img src={item?.likedByData[0]?.profilePhoto || searchhomeprofileimg} className='img-fluid' alt={item?.likedByData[0]?.personName} title={item?.likedByData[0]?.personName} /></Link> :
                                                                        item.connectionSendorId ? <Link to={`/profile/${item?.connectionSendorData[0]?.userName}`} onClick={() => {
                                                                            readNotification();
                                                                            closeNotifiBar();
                                                                        }}><img src={item?.connectionSendorData[0]?.profilePhoto || searchhomeprofileimg} className='img-fluid' alt={item?.connectionSendorData[0]?.personName} title={item?.connectionSendorData[0]?.personName} /></Link> :
                                                                            item.connectionReceiverId ? <Link to={`/profile/${item?.connectionReceiverData[0]?.userName}`} onClick={() => {
                                                                                readNotification();
                                                                                closeNotifiBar();
                                                                            }}><img src={item?.connectionReceiverData[0]?.profilePhoto || searchhomeprofileimg} className='img-fluid' alt={item?.connectionReceiverData[0]?.personName} title={item?.connectionReceiverData[0]?.personName} /></Link> :
                                                                                item.postedBy ? <Link to={`/profile/${item?.postedByData[0]?.userName}`} onClick={() => {
                                                                                    readNotification();
                                                                                    closeNotifiBar();
                                                                                }}><img src={item?.postedByData[0]?.businessProfilePic || searchhomeprofileimg} className='img-fluid' alt={item?.postedByData[0]?.personName} title={item?.postedByData[0]?.personName} /></Link> :
                                                                                    item.businessEnquiryId ? <img src={item?.enqueryByData[0]?.profilePhoto || searchhomeprofileimg} className='img-fluid' alt={item?.enqueryByData[0]?.personName} title={item?.enqueryByData[0]?.personName} /> :
                                                                                        <img src={neooIcon} className='img-fluid' alt='...' />
                                                    }


                                                </div>
                                                {/* <p className='text'>
                                                    <b><span>Congratulations!</span> You have earned $27.23 cash reward
                                                        Ashwin Bose,</b> your friend, has joined by your referral code.
                                                    Do more invitations to earn more.
                                                </p> readStatus: "unread" */}
                                                <div className='text'
                                                    style={{
                                                        cursor: "pointer",
                                                        fontWeight: item?.readStatus === "unread" ? "bold" : "normal"
                                                    }}
                                                    onClick={() => readNotification()}
                                                >
                                                    {
                                                        item?.likedBy && <><strong>{item?.likedByData[0]?.personName}</strong>&nbsp;</>
                                                    }

                                                    {
                                                        item?.visitedBy && <><strong>{item?.visitedByData[0]?.personName}</strong>&nbsp;</>
                                                    }

                                                    {
                                                        item?.connectionSendorId && <><strong>{item?.connectionSendorData[0]?.personName}</strong>&nbsp;</>
                                                    }

                                                    {
                                                        item?.connectionReceiverId && <><strong>{item?.connectionReceiverData[0]?.personName}</strong>&nbsp;</>
                                                    }

                                                    {item?.point ? "Reward points collected:" : (item?.addedBy === "admin" && item?.notification.length > 50) ? <><div dangerouslySetInnerHTML={{ __html: item?.notification?.substring(0, 47) }} />...</> : <div dangerouslySetInnerHTML={{ __html: item?.notification }} />}
                                                    {
                                                        item?.postedBy && <><br /><Link to={`/ownpostpage/${item?.businessPostId}`} onClick={() => {
                                                            readNotification();
                                                            closeNotifiBar();
                                                        }}>Click here</Link> to view.</>
                                                    }
                                                    {
                                                        item?.postEnquiryId && <><br /><Link to="/myenquiries" state={{ enquiryTab: 2 }} onClick={() => {
                                                            readNotification();
                                                            closeNotifiBar();
                                                        }}>Click here</Link> to view.</>
                                                    }
                                                    {
                                                        item?.businessEnquiryId && <><br /><Link to="/myenquiries" state={{ enquiryTab: 1 }} onClick={() => {
                                                            readNotification();
                                                            closeNotifiBar();
                                                        }}>Click here</Link> to view.</>
                                                    }
                                                    {
                                                        item?.point && <>&nbsp;<strong>{item?.point}</strong></>
                                                    }
                                                    {
                                                        item?.addedBy === "admin" && item?.notification.length > 50 && <><Link onClick={(e) => ViewNotificationMessage(e, item?.notification)}>read more</Link></>
                                                    }
                                                    {
                                                        item?.msgLink && <><p style={{ marginTop: "10px" }}><a href={item?.msgLink} target="_blank">{item?.msgLink}</a></p></>
                                                    }
                                                    {/* {
                                                        item?.likedBy && <><p style={{paddingLeft:"50px"}}><a href={`/profile/${item?.likedByData[0]?.userName}`}>View profile</a></p></>
                                                    } */}

                                                    {/* {
                                                        item?.visitedBy && <><p style={{paddingLeft:"50px"}}><a href={`/profile/${item?.visitedByData[0]?.userName}`}>View profile</a></p></>
                                                    } */}
                                                    {/* {
                                                        item?.connectionSendorId && <><br /><button onClick={(e) => handleAcceptConnectionRequest(e, item?._id,item?.connectionSendorId)} className='btn btn-sm btn-success'>Accept</button></>
                                                    } */}
                                                </div>


                                            </div>
                                            <div className='right'
                                            // ref={divRef}
                                            >
                                                <button className='more_btn' onClick={(e) => toggleDropdown(e, item?._id)}>
                                                    <i className="fa-solid fa-ellipsis"></i>
                                                    {isOpen && menuNotificationID === item?._id && (
                                                        <div className='morebtn_dropdown' ref={divRef} >
                                                            <ul>
                                                                <li className='item'
                                                                    onClick={(e) => { handleDelete(e, item?._id) }}
                                                                >
                                                                    <i className="fa-solid fa-trash-can"></i>
                                                                    Delete notification
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}
                                                </button>

                                                <p className='datetime'>{formatDateAgo(item?.createdOn)}</p>
                                                {/* <p className='status'><i className="fa-solid fa-circle"></i></p> */}
                                            </div>
                                        </div>
                                    ))}

                            </>

                        ) : (
                            <>
                                <div className='no_Notification'>
                                    <div className='icon'>
                                        <img src={noicon} className='img-fluid' alt='...' />
                                    </div>

                                    <h4 className='name'>No Notification</h4>
                                    <p className='desc'> We’ll let you know when there will be
                                        something . to update you.</p>

                                </div>
                            </>
                        )
                    }
                </div>
            </section>
        </>
    )
}

export default NotificationBar